import React from 'react'
import getPerformancesIntervallByMovies from '../functions/getPerformancesIntervallByMovies'
import Translation from '../General/Translation'
import ShowtimeDayItem from './ShowtimeDayItem'
import { DAYWHEEL } from '../constants/showtimesTypes'
import { SliderArrowNext, SliderArrowPrev } from '../SliderGeneral/SliderArrows'
import Slider from 'react-slick'
import config from '../config.json'

const Showtimes = ({
    items, 
    moviesData, 
    translation, 
    hasTitle, 
    scrollToPosition, 
    additionalScrollName, 
    startDate,
    endDate,
    programOverviewShowtimesType, 
    filterPerformances, 
    onClickItem, 
    activeFilters=false, 
    clusterCinemaActive,
    activeCinema 
}) => {
    const { perfOrder, perfItems } = getPerformancesIntervallByMovies(moviesData, items, filterPerformances, translation.timezone, activeFilters, clusterCinemaActive, activeCinema, startDate, endDate)
    const daySliderSettings = {
        ... config.sliderSettings.showtimesDaySettings,
        nextArrow: <SliderArrowNext />,
        prevArrow: <SliderArrowPrev />
    }

    const addClass = hasTitle ? ' has-title' : ''

    if(programOverviewShowtimesType === DAYWHEEL) {
        return (
            <div className={"showtimes gradient-showtimes" + addClass}>
                <div className="showtimes-wrapper">
                    {hasTitle && <div className="showtimes-title title-xlarge-bold">
                        <Translation id="program" trans={translation}/>
                    </div>}
    
                    <div className="slider-showtimes">
                        {perfOrder.length < 4 ? (
                            <div className='date-slider-day-container grid'>
                                {perfOrder.map((dayPk, index) => {
                                    const items = perfItems[dayPk]
                                    const dayItemsLength = items.length

                                    return dayItemsLength > 0 && <div className='date-slider-day-wrapper' key={index}>
                                        <ShowtimeDayItem
                                            key={index} 
                                            activeFilters={activeFilters}
                                            activeCinema={activeCinema}
                                            dayKey={dayPk} 
                                            items={items}
                                            translation={translation}
                                            scrollToPosition={scrollToPosition}
                                            additionalScrollName={additionalScrollName}
                                            onClickItem={onClickItem}
                                        />
                                    </div>
                                })}
                        </div>
                        ) : ( 
                            <Slider className='showtimes-date-slider' {...daySliderSettings}>
                                {perfOrder.map((dayPk, index) => {
                                    const items = perfItems[dayPk]
                                    const dayItemsLength = items.length

                                    return dayItemsLength > 0 && <div className='date-slider-day-wrapper' key={index}>
                                        <ShowtimeDayItem
                                            key={index} 
                                            activeFilters={activeFilters}
                                            activeCinema={activeCinema}
                                            dayKey={dayPk} 
                                            items={items}
                                            translation={translation}
                                            scrollToPosition={scrollToPosition}
                                            additionalScrollName={additionalScrollName}
                                            onClickItem={onClickItem}
                                        />
                                    </div>
                                })}
                            </Slider>
                        )}
                    </div>
                </div>
            </div>
        )        
    } else {
        return (
            <div className={"showtimes gradient-showtimes" + addClass}>
                <div className="showtimes-wrapper">
                    {hasTitle && <div className="showtimes-title title-xlarge-bold">
                        <Translation id="program" trans={translation}/>
                    </div>}
    
                    <ul className="grid-showtimes">
                        {perfOrder.map((itemId, index) => (
                            <ShowtimeDayItem
                                key={index} 
                                activeFilters={activeFilters}
                                activeCinema={activeCinema}
                                dayKey = {itemId} 
                                items={perfItems[itemId]}
                                additionalScrollName={additionalScrollName}
                                translation={translation}
                                scrollToPosition={scrollToPosition}
                                onClickItem={onClickItem}
                            />
                        ))}
                    </ul>
                </div>
            </div>
        )
    }    
}

export default Showtimes